/**
 * The options named by `ids`, in the ids' order.
 *
 * Ids with no option are dropped: option lists are narrowed per page and per
 * locale, so a deep link can carry an id this page cannot name — and a raw id
 * is nothing a visitor can read or act on.
 */
export function pick<T extends { id: string }>(
  options: T[],
  ids: string[]
): T[] {
  return ids.flatMap((id) => options.filter((option) => option.id === id));
}
